export type DayTypeFilter = 'any' | 'workdays' | 'saturdays' | 'sundays' | 'weekends';

const validDayTypes: DayTypeFilter[] = ['any', 'workdays', 'saturdays', 'sundays', 'weekends'];

export function normalizeDayTypeFilter(value?: string | DayTypeFilter, fallback: DayTypeFilter = 'workdays'): DayTypeFilter {
  if (!value) return fallback;
  const normalized = value.toString().trim().toLowerCase() as DayTypeFilter;
  return (validDayTypes as string[]).includes(normalized) ? normalized : fallback;
}

export const dayTypeOptions: { key: DayTypeFilter; value: DayTypeFilter; text: string }[] = [
  { key: 'any', value: 'any', text: 'Any days' },
  { key: 'workdays', value: 'workdays', text: 'Weekdays' },
  { key: 'saturdays', value: 'saturdays', text: 'Saturdays' },
  { key: 'sundays', value: 'sundays', text: 'Sundays' },
  { key: 'weekends', value: 'weekends', text: 'Weekends' },
];
